<template>
  <div class="carinfo">
    <van-row class="f-14 carsName">
      <van-col span="4">认证车型</van-col>
      <van-col class="text-r van-ellipsis" offset="1" span="19">{{carsName}}</van-col>
    </van-row>
    <div @click="uploadTravel" v-if="aretype!=2&&is_have_card==1">
      <div v-if="is_have_card==1">
        <div :class="showborderT?'showborder idcard text-c':'idcard text-c'" :style="'background-image:url('+img.travel+')'">
          <div v-show="travel">
            <img width="40" :src="img.camera">
            <div class="f-13 f-w">添加行驶证照片(必填)</div>
          </div>
        </div>
      </div>
    </div>
    <div @click="uploadDriving" v-if="carShow==1">
      <div :class="showborderC?'showborder idcard text-c':'idcard text-c'" :style="'background-image:url('+img.car_pic_url+')'">
        <div v-show="driving">
          <img width="40" :src="img.camera">
          <div class="f-13 f-w" v-if="is_have_card==1">请上传一张您爱车的照片（选填）</div>
          <div class="f-13 f-w" v-if="is_have_card==0">请上传一张您爱车的照片</div>
        </div>
      </div>
    </div>
    <div @click="uploadDriving" v-if="carShow==2">
      <div class="c-gray f-12">我的爱车</div>
      <div :class="showborderC?'showborder idcard text-c':'idcard text-c'" :style="'background-image:url('+img.car_pic_url+')'">
        <div v-show="driving">
          <img width="40" :src="img.camera">
          <div class="f-13 f-w">请上传一张您爱车的照片（选填）</div>
        </div>
      </div>
      <div class="c-gray f-12">认证时间：{{start_at}}</div>
    </div>
    <div class="falv_box" v-if="showa">
      <van-checkbox class="f-11" v-model="checked" checked-color="#605C6B" icon-size="15" @change="changeCheck">
        我已阅读并同意
      </van-checkbox>                            
      <div class="c-conten f-11" @click="goFalv">《凌志范儿车主认证个人信息保护声明》</div>
    </div>
    <div v-if='showa' class="text-c">
      <van-button size="large" :disabled="!checked" @click="updateInfo">提交认证信息</van-button>
    </div>
  </div>
</template>
<script>
  import info from '../../../api/member/mycars';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Uploader, Checkbox, CheckboxGroup, Button, Row, Col, Icon,Dialog } from "vant";
  export default {
    data () {
      return {
        travel:true,
        driving:true,
        checked: false,
        carsName:'',
        showa:true, 
        showborderT:true,
        showborderC:true,
        carpicshow:true,
        carShow:1,
        is_audit:0,
        aretype:'',
        ever:0,
        car_name:'',
        car_generation_name:'',
        car_model_name:'',
        is_have_card: 1,
        img:{
          travel: require('../../../assets/img/travel.png'),
          driving: require('../../../assets/img/driving.png'),
          car_pic_url: require('../../../assets/img/mycars.png'),
          camera: require('../../../assets/img/camera.png'),
          car_card:'',
          driver_card:'',
          car_pic:''
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.weburl=process.env.VUE_APP_URL
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      var ever=this.$route.query.ever
      this.region=this.$route.query.type
      this.ever=this.$route.query.ever
      this.is_have_card=this.$route.query.is_have_card
      this.car_name=this.$route.query.car_name
      this.car_generation_name=this.$route.query.car_generation_name
      this.car_model_name=this.$route.query.car_model_name
      if(this.$route.query.carname) {           
        this.carsName=this.$route.query.carname
        this.car_id=this.$route.query.id
        this.car_generation_id=this.$route.query.gid
        this.car_model_id=this.$route.query.model_id
        this.showborder=true
        if(this.$route.query.type==2){
          this.aretype=2
        }
      } else if (this.$route.query.carid) {
        this.audit=this.$route.query.audit
        this.carid=this.$route.query.carid
        this.getCarinfo(this.carid)
        if(this.$route.query.audit=='1'){
          this.showa=false
          this.showborderT=false
          this.showborderC=false
        }
      }
      var params={
        event_code: '车主认证_上传资料',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/CarInfo.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      getCarinfo(id){
        info.getCarinfo(id).then(res => {
          if(res.data.state == 1) {
            let info=res.data.data
            if(info.car){
              this.car_id=info.car.id
            }
            if(info.car_model){
              this.car_model_id=info.car_model.id
              this.carsName=info.brand.title + ' ' +info.car_model.title
            }else{
              this.carsName=info.brand.title + ' ' +info.car_model_name
            }
            
            this.brand_id=info.brand.id
            
            
            this.is_audit= info.is_audit
            this.start_at= info.start_at
            this.car_name= info.start_at
            this.car_generation_name= info.car_generation_name
            this.car_model_name= info.car_model_name
            this.is_have_card=info.is_have_card
            this.aretype=info.region
            if(info.is_audit==0||info.is_audit==2){
              this.carShow=1
              if(info.car_card_url){
                this.img.travel=info.car_card_url
                this.img.car_card=info.car_card
                this.carpicshow=true
                this.showborderT=false
                this.travel=false
              }else{
                this.carpicshow=false
                this.showborderT=true
              }
              if(info.car_pic_url){
                this.img.car_pic_url=info.car_pic_url
                this.img.car_pic=info.car_pic
                this.showborderC=false
                this.driving=false
              }else{
                this.showborderC=true
              }
            }else{
              if(info.car_card_url){
                this.img.travel=info.car_card_url
                this.img.car_card=info.car_card
                this.carpicshow=true
                this.showborderT=false
                this.travel=false
              }else{
                this.carpicshow=false
                this.showborderT=true
              }
              if(info.car_pic_url){
                this.carShow=2
                this.img.car_pic_url=info.car_pic_url
                this.img.car_pic=info.car_pic
                this.showborderC=false
                this.driving=false
              }else{
                this.carShow=3
                this.showborderC=true
              }
            }
            
          }
        })
      },
      uploadTravel(file) {
        var params={
          type:1
        }
        this.$appService.openPhotoAlbum(params,v => {
          console.log('travel---openPhotoAlbum=='+v.pic_url)
          this.img.travel=v.pic_url
          this.img.car_card=v.pic
          this.travel=false
          this.showborderT=false
        })
      },
      uploadDriving(file) {
        var params={
          type:1
        }
        this.$appService.openPhotoAlbum(params,v => {
          console.log('driving---openPhotoAlbum=='+v.pic_url)
          this.img.car_pic_url=v.pic_url
          this.img.car_pic=v.pic
          this.driving=false
          this.showborderC=false
        })
      },
      changeCheck(){
        let car_card= this.img.car_card
        let driver_card= this.img.driver_card
        let car_pic=this.img.car_pic

        // if(car_card==''&&this.region==1){
        //   if(this.is_have_card==1){
        //     this.checked=false
        //     this.$toast('请上传行驶证照片');
        //     return true
        //   }
        // }
        if(car_pic==''&&this.is_have_card==0){
          this.checked=false
          this.$toast('请上传您的爱车照片');
          return false

        }
      },
      updateInfo(){
        let car_card= this.img.car_card
        let driver_card= this.img.driver_card

        // if(car_card==''&&this.region==1){
        //   if(this.is_have_card==1){
        //     this.$toast('请上传行驶证照片');
        //     return false
        //   }
        // }
        if(driver_card==''&&this.is_have_card==0){
          this.$toast('请上传您的爱车照片');
          return false
        }
        let params={
          source:this.source,
          brand_id:1,
          car_id:this.car_id,
          car_model_id:this.car_model_id,
          car_card:this.img.car_card,
          driver_card:this.img.driver_card,
          car_pic:this.img.car_pic,
          car_name: this.car_name,
          car_generation_name: this.car_generation_name,
          car_model_name: this.car_model_name,
          is_owned: this.ever,
          is_have_card: this.is_have_card
        }
        if(this.audit==0){
          info.updateInfo(this.carid,params).then(res => {
            if(res.data.state == 1) {
              this.$toast.success('保存成功');
              if (this.is_have_card == 1 && this.img.car_card == '') {
                var params={
                  url:this.weburl+'/lexus/my/car_audit?tips=1&source='+this.source
                }
                this.$appService.openWebView(params)
              } else {
               var params={
                url:this.weburl+'/lexus/my/car_audit?source='+this.source
              }
              this.$appService.openWebView(params)
            }
            
          }
        })
        }else{
          info.addInfo(params).then(res => {
            if(res.data.state == 1) {
              this.$toast.success('保存成功');
              if (this.is_have_card == 1 && this.img.car_card == '') {
                var params={
                  url:this.weburl+'/lexus/my/car_audit?tips=1&source='+this.source
                }
                this.$appService.openWebView(params)
              } else {
               var params={
                url:this.weburl+'/lexus/my/car_audit?source='+this.source
              }
              this.$appService.openWebView(params)
            }
          }
        })

        }
      },
      goFalv(){
        var params={
          url:this.weburl+'/lexus/carstate?source='+this.source,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }
    },
    components: {
      [Uploader.name]:Uploader,
      [Row.name]: Row,
      [Col.name]:Col,
      [Checkbox.name]:Checkbox,
      [CheckboxGroup .name]: CheckboxGroup,
      [Button.name]:Button,
      [Icon.name]:Icon,
      [Dialog.name]:Dialog
    }
  };
</script>

<style lang="scss">
.carinfo{
  padding: 15px;
  .carsName{
    padding-bottom: 15px;
    border-bottom:0.5px solid #A0A0A0;
  }
  .showborder{
    border: 2.5px dashed #979797;
  }
  .idcard{
    height: 200px;
    margin-top: 15px;
    border-radius: 15px;
    background-size: cover;
    background-position:center;
    img{
      margin-top: 20%;
    }
  }
  .van-uploader{
    width: 100%;

    .van-uploader__input-wrapper{
      width: 100%;
    }
  }
  .f-12{
    margin-top: 15px;

    .c-grod{
      color: #605C6B;
    }
  }
  .text-c{
    margin-top: 15px;
  }
  .van-button--large{
    width: 100%;
    height: 45px;
    color: #fff;
    line-height: 2;
    background-color: #605C6B;
  }
  .van-col{
    .van-icon{
      margin-top: 2px;
    }
  }
  .falv_box{
    display: flex;
    align-items: center;
    margin-top: 10px;
  }
}
</style>
